exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-tooltip[data-v-2ccfd096]{background:#fff;color:#333;padding:15px;border-radius:10px;box-shadow:0 4px 12px rgba(0,0,0,.15);font-size:10px;min-width:150px;text-align:left;font-family:Poppins,sans-serif}.tooltip-date[data-v-2ccfd096]{font-size:11px;font-weight:700;color:#666;margin-bottom:8px}.tooltip-series[data-v-2ccfd096]{display:flex;align-items:center;margin:6px 0;color:#444}.tooltip-total[data-v-2ccfd096]{font-weight:700;font-size:10px;color:#222;text-align:right;margin-top:10px}", ""]);

// exports
